export default __webpack_public_path__ + "static/media/anywhere_dashboard1.aa774216.webp";